<div class="content">

  <div class="profile-box">
    <mat-card class="profile-card mat-elevation-z3">
      <mat-card-title> Dr.-Ing. Markus&nbsp;Schwehm</mat-card-title>
      <br>
      <mat-card-title>Profile</mat-card-title>
      <p>Dr. Markus Schwehm has studied mathematics at the
        Technical Universities in Karlsruhe and Munich and received
        a degree as doctor-engineer in computer science from the
        University of Erlangen-Nürnberg. After a post doc position at
        Tandem Computers in Cupertino, CA, he worked as a
        research assistant at the Universities of Stuttgart and
        Tübingen.</p>

      <p>In 2003 he started research in the field of computational
        epidemiology at the University Clinic of Tübingen. In 2005
        he established the private company ExploSYS GmbH that
        offers contract research, software development services and
        consulting for research institutes, public and private health
        agencies and pharmaceutical companies.</p>
    </mat-card>

    <mat-card class="publications-card mat-elevation-z3">

      <mat-card-title>Publications 2004-2022</mat-card-title>

      <p>Daniel Molnar, Anastassia Anastassopoulou, Barbara Poulsen Nautrup, Ruprecht Schmidt-Ott,
        Martin Eichner, Markus Schwehm, Gael Dos Santos, Bernhard Ultsch, Rafik Bekkat-Berkani, 
        Alfred von Krempelhuber, Ilse Van Vlaenderen, Laure-Anne Van Bellinghen: 
        <i>Cost-utility analysis of increasing uptake of universal seasonal quadrivalent influenza 
          vaccine (QIV) in children aged 6 months and older in Germany.</i> 
        Human Vaccines & Immunotherapeutics Vol. 18, No. 5 (2022)</p>

      <p>Rui Cai, Laetitia Gerlier, Martin Eichner, Markus Schwehm, Sankarasubramanian Rajaram, 
        Joaquin MouldQuevedo, Mark Lamotte: 
        <i>Cost-effectiveness of the cell-based quadrivalent versus the standard egg-based
          quadrivalent influenza vaccine in Germany.</i> 
        Journal of Medical Economics Bd. 24, H. 1, S. 490-501 (2021)</p>

      <p>Kristan A. Schneider, Gideon A. Ngwa, Markus Schwehm, Linda Eichner, Martin Eichner: 
        <i>The COVID-19 pandemic preparedness simulation tool: CovidSIM.</i> 
        BMC Infectious Diseases Bd. 20, Article 859 (2020)</p>

      <p>Nick Wilson, Markus Schwehm, Ayesha J Verrall, Mathhew Parry, Michael G Baker, 
        Martin Eichner:
        <i>Detecting the re-emergent COVID-19 pandemic after elimination: modelling study 
          of combined primary care and hospital surveillance.</i>
        The New Zealand medical journal 133 (1524):28-39 (2020)</p>

      <p>Rui Cai, Martin Eichner, Markus Schwehm, Sankarasubramanian Rajaram, Joaquin Quevedo, 
        Mark Lamotte: 
        <i>Cost-Effectiveness of the CELL-Based Quadrivalent Versus the Standard Egg-Based
          Quadrivalent Influenza Vaccine in Germany.</i>
        Value in Health Vol. 23, Supplement 2, S549 (2020)</p>

      <p>Rui Cai, Markus Schwehm, Joaquin Quevedo: 
        <i>Budget IMPACT Analysis of the CELL-Based Quadrivalent Influenza Vaccine in the 
          German Population Using a Dynamic Transmission MODEL Approach.</i> 
        Value in Health 23: S721 (2020)</p>

      <p>Nick Wilson, Lucy Telfar Barnard, Amanda Kvalsvig, Ayesha Verrall, Michael Baker, 
        Markus Schwehm:
        <i>Modelling the Potential Health Impact of the COVID-19 Pandemic on a Hypothetical 
          European Country</i>
        (preprint 2020)</p>

      <p>Ruprecht Schmidt-Ott, Daniel Molnar, Anastassia Anastassopoulou, Emad Yanni, 
        Claudia Krumm, Rafik Bekkat-Berkani, Gaël Dos Santos, Philipp Henneke, Markus Knuf, 
        Markus Schwehm, Martin Eichner:
        <i>Assessing direct and indirect effects of pediatric influenza vaccination in Germany 
          by individualbased simulations.</i>
        Human Vaccines & Immunotherapeutics 16(8) (2019)</p>

      <p>Shinya Tsuzuki, Markus Schwehm, Martin Eichner: 
        <i>Simulation studies to assess the long-term effects of Japan's change from trivalent 
          to quadrivalent influenza vaccination.</i> 
        Vaccine, Bd. 36, H. 5, S. 624-630 (2018)</p>

      <p>Martin Eichner, Markus Schwehm, Linda Eichner, Laetitia Gerlier: 
        <i>Direct and indirect effects of influenza vaccination.</i> 
        BMC Infectious Diseases Bd. 17, Article 308 (2017)</p>

      <p>Laetitia Gerlier, Mark Lamotte, Sylvie Greneche, Xavier Lenne, Fabrice Carrat, 
        Catherine Weil-Olivier, Oliver Damm, Markus Schwehm, Martin Eichner: 
        <i>Assessment of Public Health and Economic Impact of Intranasal Live-Attenuated 
          Influenza Vaccination of Children in France Using a Dynamic Transmission Model.</i> 
        Applied Health Economics and Health Policy Bd. 15, H. 2, S. 261-276 (2017)</p>

      <p>Laetitia Gerlier, Judith Hackett, Richard Lawson, Sofia Dos Santos Mendes, 
        Catherine Weil-Olivier, Markus Schwehm, Martin Eichner: 
        <i>Direct and Indirect Protection with Pediatric Quadrivalent Live-Attenuated Influenza 
          Vaccination in Europe Estimated by a Dynamic Transmission Model.</i> 
        Journal of Health Economics and Outcomes Research 5(1):89-108 (2017)</p>

      <p>Laetitia Gerlier, Mark Lamotte, Sylvie Grenèche, Xavier Lenne, Fabrice Carrat, 
        Catherine Weil-Olivier, Oliver Damm, Markus Schwehm, Martin Eichner: 
        <i>Assessment of Public Health and Economic Impact of Intranasal Live-Attenuated 
          Influenza Vaccination of Children in France Using a Dynamic Transmission Model.</i> 
        Applied Health Economics and Health Policy Vol. 15, pages261–276 (2017)</p>

      <p>Ruprecht Schmidt-Ott, Markus Schwehm, Martin Eichner: 
        <i>Influence of social contact patterns and demographic factors on influenza 
          simulation results.</i> 
        BMC Infectious Diseases Bd. 16, Article 646 (2016)</p>

      <p>Christiaan Dolk, Martin Eichner, Robert Welte, Anastassia Anastassopoulou, 
        Laure-Anne Van Bellinghen, Barbara Poulsen Nautrup, Ilse Van Vlaenderen, 
        Ruprecht Schmidt-Ott, Markus Schwehm, Maarten Postma: 
        <i>Cost-Utility of Quadrivalent Versus Trivalent Influenza Vaccine in Germany,
          Using an Individual-Based Dynamic Transmission Model.</i> 
        Pharmacoeconomics Bd. 34, H. 12, S. 1299-1308 (2016)</p>

      <p>Laetitia Gerlier, Mark Lamotte, Sofia Dos Santos Mendes, Oliver Damm, Markus Schwehm, 
        Martin Eichner: 
        <i>Estimates of the Public Health Impact of a Pediatric Vaccination Program Using an 
          Intranasal Tetravalent Live-Attenuated Influenza Vaccine in Belgium.</i> 
        Pediatric Drugs Bd. 18, H. 4, S. 303-318 (2016)</p>

      <p>Christiaan Dolk, Martin Eichner, René Welte, Anastassia Anastassopoulou, 
        Laure-Anne Van Bellinghen, Barbara Poulsen Nautrup, Ilse Van Vlaenderen, 
        Ruprecht Schmidt-Ott, Markus Schwehm, Maarten Postma: 
        <i>Cost-Effectiveness analysis of Quadrivalent Versus trivalent Influenza Vaccination 
          In Germany — Linking a Dynamic Transmission Model with Health and Economic Outcomes.</i> 
        Value in Health 18(7):A339 (2015)</p>

      <p>Martin Eichner, Markus Schwehm, Johannes Hain, Helmut Uphoff, Bernd Salzberger, 
        Markus Knuf, Ruprecht Schmidt-Ott: 
        <i>4Flu - an individual based simulation tool to study the effects of quadrivalent
          vaccination on seasonal influenza in Germany.</i> 
        BMC Infectious Diseases Bd. 14, Article 365 (2014)</p>
      
      <p>Markus A. Rose, Oliver Damm, Wolfgang Greiner, Markus Knuf, Peter Wutzler, 
        Johannes G. Liese, Hagen Krueger, Ulrich Wahn, Tom Schaberg, Markus Schwehm, 
        Thomas F.Kochmann, Martin Eichner: 
        <i>The epidemiological impact of childhood influenza vaccination using live-attenuated 
          influenza vaccine (LAIV) in Germany: predictions of a simulation study.</i> 
        BMC Infectious Diseases Bd. 14, Article 40 (2014)</p>

      <p>Beatriz Vidondo, Markus Schwehm, Andrea Buehlmann, Martin Eichner: 
        <i>Finding and removing highly connected individuals using suboptimal vaccines.</i> 
        BMC Infectious Diseases Bd. 12, Article 51 (2012)</p>

      <p>Martin Eichner, Markus Schwehm, Nick Wilson, Michael Baker: 
        <i>Small Islands and Pandemic Influenza.</i>
        Hospitality and Health, Jaime Seba (ed.), Apple Academic Press, New York pp.76-82 (2011)</p>

      <p>Angela Kempel-Waibel, Markus Schwehm: 
        <i>Comparison of Two Dynamic Models Predicting Future Burden of Illness of Hepatitis C 
          (HCV) in the EU5 (France, Germany, Italy, Spain, UK).</i> 
        Value in Health 14(7) (2011)</p>

      <p>Rafael Mikolajczyk, Ralf Krumkamp, Reinhard Bornemann, Amena Ahmad, Markus Schwehm, 
        Hans-Peter Duerr: 
        <i>Influenza - Einsichten aus mathematischer Modellierung.</i> 
        Deutsches Ärzteblatt 106(47):777-82 (2009)</p>

      <p>Beatriz Vidondo, Jürgen Oberreich, Stefan O. Brockmann, Hans-Peter Duerr, 
        Markus Schwehm, Martin Eichner: 
        <i>Effects of interventions on the demand for hospital services in an influenza pandemic: 
          a sensitivity analysis.</i> 
        Swiss Medical Weekly 139(35-36). 505-10 (2009)</p>

      <p>Martin Eichner, Markus Schwehm, Nick Wilson, Michael G Baker: 
        <i>Small islands and pandemic influenza: Potential benefits and limitations of 
          travel volume reduction as a border control measure.</i> 
        BMC Infectious Diseases 9:160 (2009)</p>

      <p>Markus Schwehm, Nick Wilson: 
        <i>Potential impact of pandemic influenza interventions in New Zealand: 
          a brief modelling study.</i> 
        New Zealand Medical Journal 122(1291) 117-21 (2009)</p>

      <p>Martin Eichner, Markus Schwehm, Hans-Peter Duerr, Mark Witschi, Daniel Koch, 
        Stefan O. Brockmann, Beatriz Vidondo: 
        <i>Antiviral prophylaxis during pandemic influenza may increase drug resistance.</i> 
        BMC Infectious Diseases 9:4 (2009)</p>

      <p>Stefan O. Brockmann, Markus Schwehm, Hans-Peter Duerr, Mark Witschi, Daniel Koch, 
        Beatriz Vidondo, Martin Eichner: 
        <i>odeling the effects of drug resistant influenza virus in a pandemic.</i>
        Virology Journal 5(1):133 (2008)</p>

      <p>Hans-Peter Duerr, Markus Schwehm, Christopher C. Leary, Sake J. de Vlas, Martin Eichner: 
        <i>The impact of contact structure on infectious disease control: 
          influenza and antiviral agents.</i> 
        Epidemiology and Infection 135(7):1124-32 (2007)</p>

      <p>Hans-Peter Duerr, Stefan O. Brockmann, Isolde Piechotowski, Markus Schwehm, Martin Eichner:
        <i>Influenza pandemic intervention planning using InfluSim: pharmaceutical and 
          non-pharmaceutical interventions.</i> 
        BMC Infectious Diseases 7:76 (2007)</p>

      <p>Martin Eichner, Markus Schwehm, Hans-Peter Duerr, Stefan O. Brockmann: 
        <i>The influenza pandemic preparedness planning tool InfluSim.</i> 
        BMC Infectious Diseases 7:17 (2007)</p>

      <p>Christopher C. Leary, Markus Schwehm, Martin Eichner, Hans-Peter Duerr: 
        <i>Tuning degree distributions: Departing from scale-free networks.</i> 
        Physica A Statistical Mechanics and its Applications 382(2):731-738 (2006)</p>

      <p>Hiroshi Nishiura, Markus Schwehm, Martin Eichner: 
        <i>Still Protected Against Smallpox? Estimation of the Duration of Vaccine-Induced 
          Immunity Against Smallpox.</i> 
        Epidemiology 17(5):p 576-581 (2006)</p>

      <p>Hiroshi Nishiura, Isao Arita, Markus Schwehm, Martin Eichner: 
        <i>Epidemiologic Assessment of the Protective Effects of Smallpox Vaccination.</i> 
        American Journal of Infectious Diseases 2(1) (2006)</p>

      <p>Hiroshi Nishiura, Markus Schwehm, Masayuki Kakehashi, Martin Eichner: 
        <i>Transmission potential of primary pneumonic plague: time inhomogeneous evaluation 
          based on historical documents of the transmission network.</i> 
        Journal of Epidemiology and Community Health 60(7):640-5 (2006)</p>

      <p>Martin Eichner, Markus Schwehm, Stefan Brockmann: 
        <i>Dynamische Simulation einer Influenzapandemie 
          - Planungshilfe für Entscheidungsträger.</i> 
        Public Health Forum 14(2) (2006)</p>

      <p>Martin Eichner, Markus Schwehm: 
        <i>Smallpox: A Vulnerable Specter.</i> 
        Epidemiology 15(3):258-60 (2004)</p>

    </mat-card>
  </div>

  <div class="cv-box">
    <mat-card class="cv-card mat-elevation-z3">
      <mat-card-title>Curriculum Vitae</mat-card-title>
      <br>
      <mat-card-title>Work Experience</mat-card-title>
      <h4>Managing Director, ExploSYS GmbH, since 2005</h4>
      <p>Contract research, software development and consultancy<br>
      for research institutes, health care agencies and pharmaceutical companies.</p>
      
      <h4>Research assistant at the University Clinic of Tübingen, 2003-2008</h4>
      <p>Institute of Medical Biometry (Prof. Klaus Dietz)<br>
      Development of Models for the infective spread of smallpox, SARS, polio and inﬂuenza</p>

      <h4>Research assistant, WSI at the University of Tübingen, 1999-2003</h4>
      <p>Department for computer architecture (Prof. Andreas Zell)<br>
      Bioinformatics, Simulation of biochemical networks, systems biology</p>

      <h4>Research assistant, IPVR at the University of Stuttgart, 1997-1999</h4>
      <p>Department of distributed systems (Prof. Kurt Rothermel)<br>
      Mobile software agents, mobile context sensitive systems</p>

      <h4>Postdoc at the Tandem Research Laboratory in Cupertino, CA, USA, 1997</h4>
      <p>Development group for transactional databases (Dr. Johannes Klein)<br>
      Distributed active data bases, trigger, push-technologies</p>

      <h4>Doctoral Candidate, IMMD at the University of Erlangen-Nürnberg, 1990-1996</h4>
      <p>Department of  computer architecture and communication systems (Prof. Ulrich Herzog)<br>
      Array processors, parallel algorithms, parallel optimization methods</p>

      <h4>Civilian service,  MEDIS-Institute of the GSF Munich, 1988-1990</h4>
      <p>Institute for medical informatics and health research (Prof. Siegfried Pöppl)<br>
      Image processing, pattern recognition, neuronal networks</p>
      <br>

      <mat-card-title>Education</mat-card-title>
      Doctor-Engineer in Computer Science, University of Erlangen-Nürnberg, 1996<br>
      Diplom in Mathematics, Technical University of Munich, 1988<br>
      Pre-diplom in Mathematics, Technical University of Karlsruhe, 1985<br>
      Abitur, Staatliches Gymnasium Wörth/Rhein, 1982
    </mat-card>

    <mat-card class="projects-card mat-elevation-z3">
    
      <mat-card-title>Selected Projects</mat-card-title>

      <p><span class="run-in">KSASIM (2024-2025):</span> Ascend Solutions, Ministry of Health Saudi Arabia<br>
        Consulting and training, extension of a web application with Angular/Typescript<br>
        for the Covid-19 preparedness planning during the Hajj in Saudi Arabia </p>

      <p><span class="run-in">CovidCONTROL (2021):</span> Epimos GmbH, Landesgesundheitsamt Stuttgart<br>
        Full-stack development of a web application with Angular/Typescript/ECharts<br>
        for the projection of expected Covid-19-Cases from reported data</p>

      <p><span class="run-in">CovidSIM (2020-2021):</span> University Hospital Tübingen, Epimos GmbH, BMFT<br>
        Full-stack development of a web application with Angular/Typescript/NgRx<br>
        for the simulation of infection spread and interventions for Covid-19</p>

      <p><span class="run-in">TOMMI (2019):</span> Pharmametrics GmbH, Celgene Corp.<br>
        Converting an Excel-model into a desktop application with Javascript, NW.js and D3<br>
        for a budget impact model about treatment options for multiple myeloma</p>

      <p><span class="run-in">IMAAC (2017-2021):</span> European Cooperation in Science and Technology (COST)<br>
        Science communication, development of a community website using WordPress<br>
        for an interdisciplinary network of scientists to fight mosquito-transmitted diseases</p>

      <p><span class="run-in">Network-Meta-Analysis (2016):</span> Market Access & Pricing Strategy GmbH, Adelphi Values<br>
        Data preparation and Network-Meta-Analysis with R, RStudio and WinBUGS<br>
        for integrating the results of multiple clinical studies about psoriasis treatment</p>

      <p><span class="run-in">iNET-FA2 (2015-2017):</span> Fachhochschule Südwestfalen, BMFT<br>
        Consulting and requirements analysis, develpment of a web application for the<br>
        management of intelligent power networks using Angular, ArangoDB and InfluxDB.</p>

      <p><span class="run-in">Hanta-Prediction (2014-2017):</span> Epimos GmbH, LGA Stuttgart, Forschungsplattform Zoonosen<br>
        Full-stack development of an interactive web application with JavaScript and D3<br>
        for a public early warning system for hantavirus outbreaks</p>

      <p><span class="run-in">SIM-STH (2014-2015):</span> Imperial College, LSHTM, Bill & Melinda Gates Foundation<br>
        Converting a Matlab-Model into a web application with AngularJS/Typescript and D3<br>
        for the treatment of soil-transmitted helminths in rural Afrika</p>

      <p><span class="run-in">Schis-2-HIV (2013):</span> Epimos GmbH, WHO, Bill and Melinda Gates Foundation<br>
        Development of a stochastic discrete event simulator with Java/SW<br>
        for the concurrent transmission of Schistosomiasis and HIV in rural Afrika</p>

      <p><span class="run-in">4Flu, 4Strep (2011-2020):</span> Epimos GmbH, GlaxoSmithKline Vaccines, Sequirus GmbH<br>
        Consulting and development of a desktop application with Java/SWT<br>
        for event-driven simulation of infection spread and vaccination policies.</p>

      <p><span class="run-in">LAIV, QLAIV (2011-2015):</span> Epimos GmbH, AstraZeneca GmbH<br>
        Consulting and development of a desktop application with Java/SWT<br>
        for a deterministic model pf infection spread and vaccination policies.</p>

      <p><span class="run-in">Aktiv Gegen Grippe (2010-2012):</span> ACQUISTO Inter BV, InfluenzaNET, FP7<br>
        Science communication, website development for monitoring of influenza-like-illness</p>

      <p><span class="run-in">MenschMikrobe (2009-2014):</span> k-Project, Robert Koch Institute, dfg<br>
        Science communication, development of an interactive exhibit using a touch-screen<br>
        for a science exhibition explaining disease spread to a public audience</p>
      
      <p><span class="run-in">InfluSim, InterSim, SimPox (2005-2009):</span> LGA Stuttgart, BAG Switzerland<br>
        Consulting, extension of simulators for the execution of simulation studies<br>
        for the preparedness planning for pandemic influenza and bioterror events (Smallpox)</p>

      <mat-card-title>Utilized tools / techniques / applications</mat-card-title>

      <p>Typescript, Angular, Material, NgRx, NgD3, ECharts, GIT, GITlab, HTML5, CSS, JavaScript,
      D3, Bootstrap, WebGL, Java, Swing, SWT, JFace, Node, PHP, SQL, MySQL, ArangoDB, InfluxDB,
      R, Rstudio, WinBUGS, Mathcad, Wordpress</p>

    </mat-card>
  </div>

</div>


